"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfileDetails = exports.updateEmployeeDetails = exports.updateContactPreferences = exports.sendActivationEmail = exports.businessTetherLogin = exports.bulkUploadEmployees = exports.addNewEmployee = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _gql = require("../gql");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var addNewEmployee = exports.addNewEmployee = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (companyId, languageCode, data, token) {
    return yield (0, _gql.executeGraphQLQueries)((0, _api.addEmployee)(), {
      companyId,
      languageCode,
      employee: data
    }, result => {
      var _result$data;
      if ((result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.addEmployee) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }, token, false, true);
  });
  return function addNewEmployee(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var updateEmployeeDetails = exports.updateEmployeeDetails = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (companyId, employeeId, languageCode, data, token) {
    return yield (0, _gql.executeGraphQLQueries)((0, _api.updateEmployee)(), {
      companyId,
      employeeId,
      languageCode,
      updateEmployeeCriteria: data
    }, result => {
      var _result$errors, _result$data2;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.length) > 0) {
        var lastTMError = result.errors.find(error => {
          var _error$errorInfo;
          return (error === null || error === void 0 || (_error$errorInfo = error.errorInfo) === null || _error$errorInfo === void 0 ? void 0 : _error$errorInfo.code) === _api.requestErrors.lastTravelManager;
        });
        if (lastTMError) {
          return _objectSpread(_objectSpread({}, genericError), {}, {
            error: _api.requestErrors.lastTravelManager
          });
        }
        return genericError;
      }
      if ((result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.updateEmployee) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token, false, true);
  });
  return function updateEmployeeDetails(_x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();
var updateProfileDetails = exports.updateProfileDetails = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(function* (customerId, data, token) {
    return yield (0, _gql.executeGraphQLQueries)((0, _api.updateProfileDetailsQuery)(), {
      customerId,
      business: true,
      payload: data
    }, result => {
      var _result$errors2, _result$data3;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$errors2 = result.errors) === null || _result$errors2 === void 0 ? void 0 : _result$errors2.length) > 0) {
        var currentPasswordNotMatch = result.errors.find(error => {
          var _error$errorInfo2;
          return (error === null || error === void 0 || (_error$errorInfo2 = error.errorInfo) === null || _error$errorInfo2 === void 0 ? void 0 : _error$errorInfo2.code) === _api.requestErrors.currentPasswordNotMatch;
        });
        if (currentPasswordNotMatch) {
          return _objectSpread(_objectSpread({}, genericError), {}, {
            error: _api.requestErrors.currentPasswordNotMatch
          });
        }
        return genericError;
      }
      if (result !== null && result !== void 0 && (_result$data3 = result.data) !== null && _result$data3 !== void 0 && _result$data3.updateProfileDetails.success) {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token, false, true);
  });
  return function updateProfileDetails(_x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();
var businessTetherLogin = exports.businessTetherLogin = function () {
  var _ref4 = (0, _asyncToGenerator2.default)(function* (token, tetheredGuid, locale) {
    return yield (0, _gql.executeGraphQLQueries)(_api.BUSINESS_TETHER_LOGIN, {
      loginCriteria: {
        guid: tetheredGuid,
        scheme: locale === _api.LOCALES.EN ? 'GB' : 'DE'
      }
    }, result => {
      var _result$data4;
      return result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.businessTetherLogin;
    }, token);
  });
  return function businessTetherLogin(_x13, _x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();
var sendActivationEmail = exports.sendActivationEmail = function () {
  var _ref5 = (0, _asyncToGenerator2.default)(function* (token, companyId, languageCode, emailAddress, centralCardId) {
    return yield (0, _gql.executeGraphQLQueries)(_api.SEND_ACTIVATION_EMAIL, {
      companyId,
      languageCode,
      sendActivationEmailCriteria: {
        emailAddress,
        centralCardId
      }
    }, result => {
      var _result$data5;
      return result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.sendActivationEmail;
    }, token);
  });
  return function sendActivationEmail(_x16, _x17, _x18, _x19, _x20) {
    return _ref5.apply(this, arguments);
  };
}();
var bulkUploadEmployees = exports.bulkUploadEmployees = function () {
  var _ref6 = (0, _asyncToGenerator2.default)(function* (token, companyId, file) {
    try {
      var data = new FormData();
      data.append('upFile', file);
      var res = yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/").concat(companyId, "/employees/bulk"), {
        method: 'POST',
        headers: {
          Origin: process.env.NEXT_PUBLIC_ASSETS_URL_WITHOUT_BASIC,
          Authorization: "Bearer ".concat(token)
        },
        cache: 'no-cache',
        body: data
      });
      if (!res.ok) {
        return null;
      }
      return true;
    } catch (error) {
      return null;
    }
  });
  return function bulkUploadEmployees(_x21, _x22, _x23) {
    return _ref6.apply(this, arguments);
  };
}();
var updateContactPreferences = exports.updateContactPreferences = function () {
  var _ref7 = (0, _asyncToGenerator2.default)(function* (email, token, locale, preferences) {
    try {
      var _preferences$optIn, _preferences$secondPa, _preferences$thirdPar, _response$data;
      var response = yield (0, _gql.executeGraphQLQueries)(_api.UPDATE_CONTACT_PREFERENCES, {
        contactType: 'email',
        contactValue: email,
        request: {
          brandCodes: ['PINN'],
          doubleOptIn: false,
          customer: {
            language: locale === 'en' ? 'en' : 'de',
            countryOfResidence: locale === 'en' ? 'GB' : 'DE',
            firstName: '',
            lastName: '',
            title: '',
            userId: ''
          },
          optIn: (_preferences$optIn = preferences.optIn) !== null && _preferences$optIn !== void 0 ? _preferences$optIn : false,
          secondPartyOptIn: (_preferences$secondPa = preferences.secondPartyOptIn) !== null && _preferences$secondPa !== void 0 ? _preferences$secondPa : false,
          thirdPartyVendorsOptIn: (_preferences$thirdPar = preferences.thirdPartyVendorsOptIn) !== null && _preferences$thirdPar !== void 0 ? _preferences$thirdPar : false,
          sourceDetails: {
            channel: 'BB',
            journey: 'PERMISSIONCENTRE',
            locale: locale === 'en' ? 'UK' : 'DE'
          }
        }
      }, result => result, token, true, true);
      if ((response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.updateContactPreferences) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      if (response !== null && response !== void 0 && response.errors) {
        return {
          status: _api.requestStatus.fail,
          error: _api.requestErrors.generic
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    } catch (error) {
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }
  });
  return function updateContactPreferences(_x24, _x25, _x26, _x27) {
    return _ref7.apply(this, arguments);
  };
}();